<template>
    <cta-tile v-if="showBack"
              class="cta-tile--branded"
              :name="name"
              :title="title"
              :button-text="buttonText"
              :button-operation-in-progress="ctaInProgress"
              :disabled="disabled"
              :image-url="imageUrl"
              :show-small-image="true"
              :secondary-button-text="backButtonText"
              :secondary-button-operation-in-progress="backInProgress"
              :breakout="!breakoutExtended"
              :breakout-extended="breakoutExtended"
              :icon-class="showIcon ? 'fas fa-chevron-circle-right' : ''"
              icon-location="post"
              type="cta"
              secondary-button-icon-class="fas fa-chevron-circle-left"
              secondary-button-icon-location="pre"
              @click="onClick"
              @secondary-click="onSecondaryClick" />
    <cta-tile v-else
              class="cta-tile--branded"
              :name="name"
              :title="title"
              :button-text="buttonText"
              :button-operation-in-progress="ctaInProgress"
              :disabled="disabled"
              :image-url="imageUrl"
              :show-small-image="true"
              :breakout="!breakoutExtended"
              :breakout-extended="breakoutExtended"
              :icon-class="showIcon ? 'fas fa-chevron-circle-right' : ''"
              icon-location="post"
              type="cta"
              @click="onClick" />
</template>

<script>

import AnalyticsLogger from '../analytics-logger'
import Cta from './cta'
import CtaTile from './cta-tile'

export default {

    props: {
        backButtonText: {
            type: String,
            default: 'Back a step',
        },
        backInProgress: {
            type: Boolean,
            default: null,
        },
        ctaInProgress: {
            type: Boolean,
            default: null,
        },
        showBack: {
            type: Boolean,
            default: false,
        },
        showIcon: {
            type: Boolean,
            default: false,
        },
    },

    mixins: [
        AnalyticsLogger,
        Cta,
    ],

    computed: {

        imageUrl() {
            return this.$scheme.resources.brandedImagery.cta ? `${ this.$config.baseUrl }schemes/${ this.$scheme.path }${ this.$scheme.resources.brandedImagery.cta }` : null
        },
    },

    methods: {

        onClick() {
            this.$emit('click')
            this.trackEvent('cta', this.buttonText, { label: this.buttonText })
        },

        onSecondaryClick() {
            this.$emit('back-click')
            this.trackEvent('cta_back', `Back - not ${ this.buttonText }`, { label: this.backButtonText })
        },
    },

    components: {
        CtaTile,
    },
}

</script>
